import React, { useMemo, useState } from "react";
import "./creatNewUser.css";

// Shared permission chooser for staff and company roles. Parent and child checkboxes
// occupy the same right-aligned column; selection never saves until the parent form does.
export default function PermissionSelector({ companyPermissions = [], value = [], onChange, disabled = false }) {
  const [expanded, setExpanded] = useState({});
  const [search, setSearch] = useState("");
  const groups = useMemo(() => {
    const catalogue = new Map();
    companyPermissions.forEach(permission => {
      if (!permission?.permissionId) return;
      const category = permission.category || "Other permissions";
      if (!catalogue.has(category)) catalogue.set(category, []);
      catalogue.get(category).push(permission);
    });
    return [...catalogue.entries()].map(([category, items]) => ({ category, items }));
  }, [companyPermissions]);
  const matches = item => [item.category, item.permissionId, item.module, item.description, item.name]
    .some(label => String(label || "").toLowerCase().includes(search.trim().toLowerCase()));
  const changeOne = id => onChange(value.includes(id) ? value.filter(item => item !== id) : [...value, id]);
  const changeGroup = items => {
    const ids = items.map(item => item.permissionId);
    onChange(ids.every(id => value.includes(id)) ? value.filter(id => !ids.includes(id)) : [...new Set([...value, ...ids])]);
  };
  return <div className="accessPermissionPicker">
    <div className="fx-ac fx-jb wrap space1"><h3>Permissions</h3><span className="accessMuteline">{value.length} selected</span></div>
    <div className="accessPermissionToolbar">
      <label className="profileSearch"><span className="sr-only">Search permissions</span><input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search permissions" /></label>
      <button type="button" className="profileTextButton" disabled={disabled} onClick={() => onChange([...new Set([...value, ...groups.flatMap(g => g.items.map(item => item.permissionId))])])}>Select all</button>
      <button type="button" className="profileTextButton" disabled={disabled} onClick={() => onChange([])}>Clear</button>
    </div>
    <div className="accessPermissionGroups">{groups.filter(group => group.items.some(matches)).map(group => {
      const items = group.items.filter(matches);
      const checked = group.items.filter(item => value.includes(item.permissionId)).length;
      const open = expanded[group.category] ?? Boolean(search);
      return <div className="accessPermissionGroup" key={group.category}>
        <div className="accessPermissionLine accessPermissionParent">
          <button type="button" className="accessPermissionExpand" aria-expanded={open} onClick={() => setExpanded(prev => ({ ...prev, [group.category]: !open }))}>
            <span aria-hidden="true">{open ? "▾" : "▸"}</span><span>{group.category}<small>{checked} of {group.items.length} selected</small></span>
          </button>
          <input type="checkbox" aria-label={`Select all ${group.category} permissions`} disabled={disabled}
            checked={checked === group.items.length} ref={node => { if (node) node.indeterminate = checked > 0 && checked < group.items.length; }}
            onChange={() => changeGroup(group.items)} />
        </div>
        {open && items.map(permission => <label className="accessPermissionLine accessPermissionChild" key={permission.permissionId}>
          <span>{permission.module || permission.name || permission.permissionId}<small>{permission.description || permission.permissionId}</small></span>
          <input type="checkbox" disabled={disabled} checked={value.includes(permission.permissionId)} onChange={() => changeOne(permission.permissionId)} />
        </label>)}
      </div>;
    })}</div>
    {!groups.length && <p className="accessMuteline">No permissions available. Verify the permissions catalogue on the server.</p>}
  </div>;
}
